module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/nielsen-57e943b3896c5f4d11550dbabcfa3fc9.png";